import { ReactElement } from 'react'
import { Button } from '@mui/material'

interface Props {
  /** Name of the drawn element type, e.g. "Öffnungen". */
  elementLabel: string
  onClick: () => void
  'data-cy'?: string
}

/**
 * Ends (and cancels) a drawing mode. Not to be confused with "abwählen", which only clears the
 * selection of an existing element.
 */
const EndDrawModeButton = ({ elementLabel, onClick, 'data-cy': dataCy }: Props): ReactElement => (
  <Button variant="outlined" onClick={onClick} size="small" fullWidth data-cy={dataCy}>
    {elementLabel} einzeichnen beenden
  </Button>
)

export default EndDrawModeButton
